import scrollTo from 'utils/scrollTo';

class ScrollTo {
  constructor(node, options = {}) {
    this.props = {
      ...options,
    };

    this.node = node;
    this.node.decorator = this;

    const href = this.node.getAttribute('href');

    this.target = document.querySelector(href);
    this.node.removeEventListener('click', this.onClick);
    if (this.target) {
      this.node.addEventListener('click', this.onClick);
    }
  }

  onClick = e => {
    e.preventDefault();
    scrollTo(this.target);
  };

  destroy = () => {
    this.node.removeEventListener('click', this.onClick);
  };
}

export default (node, props) => new ScrollTo(node, props);
